import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Optionnel si vous utilisez Bootstrap pour le style

const Tag = ({ icon, name, styled }) => {
  return (
    <div className={`d-flex align-items-center tag ${styled}`}>
      <img src={`/images/${icon}`} />
      <span>{name}</span>
    </div>
  );
};

export default Tag;
